// No need to manually import theme files - we grab them dynamically here, as long as the filename ends in `theme.js`
const componentThemeFiles = require.context('.', true, /theme\.js$/);

export const componentThemes = componentThemeFiles
  .keys()
  .map((k) => {
    const mod = componentThemeFiles(k);
    return mod.default;
  })
  .reduce((obj, next) => ({ ...obj, ...next }), {});

export default componentThemes;
